import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g opacity={0.5}>
      <path
        fill="#e2e7f0"
        d="M15.992 0c8.86 0 15.992 7.132 15.992 15.992s-7.132 15.992-15.992 15.992S0 24.852 0 15.992 7.132 0 15.992 0"
      />
      <path
        fill="#0e0f10"
        fillOpacity={0.05}
        fillRule="evenodd"
        d="M15.992 0C7.16 0 0 7.16 0 15.992q0 .81.079 1.6C.881 9.51 7.699 3.197 15.992 3.197s15.11 6.312 15.913 14.393q.078-.79.079-1.599C31.984 7.16 24.824 0 15.992 0"
        clipRule="evenodd"
      />
      <path
        fill="#0e0f10"
        fillOpacity={0.05}
        fillRule="evenodd"
        d="M15.992 0C7.16 0 0 7.16 0 15.992s7.16 15.992 15.992 15.992 15.992-7.16 15.992-15.992S24.824 0 15.992 0m0 1.6C8.043 1.6 1.599 8.042 1.599 15.991s6.444 14.393 14.393 14.393 14.393-6.444 14.393-14.393S23.94 1.599 15.992 1.599"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
const SvgIconRadioButtonDisabled = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconRadioButtonDisabled);
export default Memo;
